import { CURRENT_SERVER_URL } from "./localstorage_variables";
import { getData, saveData } from "./localstorage_constants";
import APPUrls from "../api/app_urls";

class CommonSettings {
  constructor() {
    this.current_server_url = "";

    // this.SERVER_BASE_URL = "http://192.168.1.5:4081/Productlicense/";
    this.SERVER_BASE_URL = "https://api.validity.zenvae.in/Productlicense/";   // Licence api 4081 , licences.zenvae.in / product_licence_client
    this.LOCAL_BASE_URL = "https://192.168.1.100:4081/Productlicense/";  // Zenvae Licence
  }

  setBaseURL(url) {
    this.current_server_url = url;
    saveData(CURRENT_SERVER_URL, url);  
    APPUrls.initUrls();
  }

  async readAndSetCurrentServer() {
    let url = await getData(CURRENT_SERVER_URL);
    if (this.SERVER_BASE_URL != url && url != this.LOCAL_BASE_URL) {
      url = null;
    }
    console.log("initial server url", url);
    if (url) {
      this.setBaseURL(url);
    } else {
      this.setBaseURL(this.SERVER_BASE_URL);
    }
    url = await getData(CURRENT_SERVER_URL);
    console.log("after change  server url", url);
    console.log(
      "after change  this.current_server_url ",
      this.current_server_url
    );
  }
}

// module.exports = new CommonSettings();
export default new CommonSettings();
